<template lang="pug">
  .login-sign-up
    p.sign-in-title.kapra-neue.upper.xs-f-xgrande.max-at-tweak Sign in or Create Your Account
    p.text-color-2.xs-f-small.max-at-tweak Enter your email or sign in with Google to continue.

    .xs-12(v-if="isCustomerPresent")
      p.xs-f-small.max-at-tweak Not you?&nbsp;
        button.login.btn-reset.underline.color-purple(@click="$root.logOut()") Log Out

    form#login-sign-up-form(@submit.prevent="getAccountStatus" novalidate)
      p.error(v-if="signInError" role="alert") {{ signInError }}
      mrInput(v-model="email" :label="'Email'" :input-type="'email'" :v="v$.email" :autocomplete="'username'" required="true" :data-mr-ass="'sign-in-email'")
      button.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(type="submit" :disabled="v$.$invalid || processing" :class="{ disabled: v$.$invalid || processing }") continue

    .or
      p.cta-color-3.xs-f-medium.max-at-tweak Or

    MrSpinnerVeil(v-if="googleLoading")
    #google-sign-in-container.text-center(v-else)
      div#google-sign-in-btn-wrapper
        div#google-sign-in-btn

    p.terms-text.text-color-2.xs-f-xsmall.max-at-tweak.pt-100m
      | By creating an account, you agree to the&#32;
      br
      a(href="/about/terms" target="_blank") Terms&nbsp;of&nbsp;Use
      |  and
      a(href="/about/privacy" target="_blank")  Privacy&nbsp;Policy

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import { required, email } from '@vuelidate/validators';
  import SignInMixin from "@components/MrSignIn/SignInMixin";
  import mrInput from "@components/mrInput";
  import MrSpinnerVeil from "@components/MrSpinnerVeil";
  import { useVuelidate } from "@vuelidate/core";

  export default {
    name: "LoginSignUp",

    components: {
      mrInput,
      MrSpinnerVeil,
    },

    mixins: [SignInMixin],

    inject: ['getObjProperty'],

    setup () {
      return {
        v$: useVuelidate(),
      };
    },

    validations: {
      email: {
        required,
        email
      }
    },

    computed: {
      ...mapState('signIn', [
        'signInError',
        'userEmail',
        'googleLoading',
        'processing',
      ]),

      email: {
        get() {
          return this.userEmail;
        },

        set(value) {
          this.setUserEmail(value);
        }
      },

      isCustomerPresent() {
        return Boolean(this.cdata?.user?.id);
      }
    },

    methods: {
      ...mapActions('signIn', [
        'getSignInData',
        'getAccountStatus'
      ]),

      ...mapMutations('signIn', [
        'setTimedOut',
        'setUserEmail'
      ]),
    },

    mounted() {
      this.getSignInData();
      this.setTimedOut(Boolean(this.getObjProperty(this.cdata, 'user.authed') && !this.$cookies.get(this.getObjProperty(this, 'MRConfig.timeoutCookie'))));
    }
  };
</script>

<style scoped lang="stylus">
  .login-sign-up
    #login-sign-up-form
      margin-top 2em

      .mr-btn
        margin-top 0.75em

    .or
      position relative
      display block
      border-top 1px solid cta-color-3
      width 100%
      text-align center
      margin 2em 0

      p
        background-color color-white
        width 3em
        position absolute
        left 50%
        top -0.8em
        margin-left -1.5em

</style>
